import { useTranslation } from "react-i18next";
import {
  Menu,
  MenuItem,
  ChartIcon,
  SubMenu,
  SettingIcon,
  DiskIcon,
  TextIcon,
  FileSearchIcon,
  FormatIcon,
} from "melco-ui";
import { useMainMenu } from "melco-shared-logic";

export const MainMenu: React.FC = () => {
  const { t } = useTranslation();
  const { selectedKeys, onClick } = useMainMenu();

  return (
    <Menu
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={selectedKeys}
      onClick={onClick}
    >
      <MenuItem key="/" icon={<ChartIcon />}>
        {t("main_menu.dashboard")}
      </MenuItem>

      <MenuItem key="/design-mappings" icon={<FormatIcon />}>
        {t("main_menu.design_mappings")}
      </MenuItem>

      <MenuItem key="/input-formats" icon={<TextIcon />}>
        {t("main_menu.input_formats")}
      </MenuItem>

      <SubMenu
        key="/libraries"
        icon={<DiskIcon />}
        title={t("main_menu.libraries")}
      >
        <MenuItem key="/libraries/designs">
          {t("main_menu.libraries_designs")}
        </MenuItem>

        <MenuItem key="/libraries/fonts">
          {t("main_menu.libraries_fonts")}
        </MenuItem>

        <MenuItem key="/libraries/font-collections/embroidery">
          {t("main_menu.libraries_font_collections_embroidery")}
        </MenuItem>

        <MenuItem key="/libraries/color-collections/embroidery">
          {t("main_menu.libraries_color_collections_embroidery")}
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="/settings"
        icon={<SettingIcon />}
        title={t("main_menu.settings")}
      >
        <MenuItem key="/settings/basic">
          {t("main_menu.settings_basic")}
        </MenuItem>
      </SubMenu>

      <MenuItem key="/logs" icon={<FileSearchIcon />}>
        {t("main_menu.logs")}
      </MenuItem>
    </Menu>
  );
};
